import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

interface AuthShellProps {
  title: string;
  description: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  badge?: string;
}

const defaultHighlights = [
  'Create payment links, invoices, and embedded checkout flows from one workspace.',
  'Keep payout routing, API access, and wallet setup easy to review and update.',
  'Track payments, exceptions, and settlement progress without jumping between tools.',
];

const AuthShell: React.FC<AuthShellProps> = ({
  title,
  description,
  children,
  footer,
  badge = 'Business Payment Workspace',
}) => {
  return (
    <div className="auth-shell">
      <Container fluid="xl" className="auth-shell__container">
        <Row className="g-4 align-items-stretch justify-content-center">
          <Col lg={6} className="d-none d-lg-block">
            <div className="auth-shell__hero">
              <div className="auth-shell__brand">
                <span className="auth-shell__brand-mark">
                  <img src="/rizzpay-mark.png" alt="RizzPay" className="auth-shell__brand-logo" />
                </span>
                <div>
                  <div className="auth-shell__brand-name">RizzPay</div>
                  <div className="auth-shell__brand-caption">Payment workspace</div>
                </div>
              </div>
              <div className="auth-shell__badge">{badge}</div>
              <h1 className="auth-shell__headline">Start taking payments from one clear workspace.</h1>
              <p className="auth-shell__description">
                RizzPay gives merchants and operators one place to launch payments, manage access, and follow settlement without extra setup steps.
              </p>

              <div className="auth-shell__spotlight">
                <div className="auth-shell__spotlight-label">What you can do here</div>
                <ul className="auth-shell__list">
                  {defaultHighlights.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>

          <Col lg={5} xl={4}>
            <Card className="auth-shell__card">
              <Card.Body className="p-4 p-md-5">
                <div className="auth-shell__panel-header">
                  <div className="auth-shell__eyebrow">Secure workspace</div>
                  <h2 className="auth-shell__title">{title}</h2>
                  <p className="auth-shell__copy">{description}</p>
                </div>

                {children}

                {footer ? (
                  <div className="auth-shell__footer">
                    {footer}
                  </div>
                ) : null}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuthShell;
